import { getVariant } from '@apia/theme';
import { ISimpleButton, SimpleButton } from '../forms';

export const ToolbarTextButton = (props: ISimpleButton) => {
  return (
    <SimpleButton
      {...props}
      className={`toolbar__textButton ${props?.className ?? ''}`}
      {...(props.variant ? getVariant(props.variant) : null)}
    >
      {props.children}
    </SimpleButton>
  );
};
